import React, { useCallback, useImperativeHandle, useRef, useState } from "react";
import { isEqual, isFunction } from "@util/utils";
import EditMemoDialog from "./EditMemoDialog";
import ProductSelectionDialog from "./ProductSelectionDialog";

const EDIT_MEMO_DIALOG = "EditMemoDialog";
const PRODUCT_SELECTION_DIALOG = "ProductSelectionDialog";

const CreateOrderDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState("");
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);

	const handleDialogClose = useCallback(
		() => {
			setOpenDialog(null);
			setSourceData(null);
		},
		// eslint-disable-next-line
		[]
	);

	const doRefresh = (...arg) => {
		if (isFunction(refreshRef.current)) {
			setTimeout(() => refreshRef.current(...arg), 5);
		}
	};

	useImperativeHandle(
		ref,
		() => ({
			// 開啟編輯備註彈窗
			openEditMemoDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(EDIT_MEMO_DIALOG);
			},
			// 開啟商品選擇彈窗
			openProductSelectionDialog: (targetData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetData);
				setOpenDialog(PRODUCT_SELECTION_DIALOG);
			},
			// 關閉彈窗
			closeDialog: () => {
				handleDialogClose();
			},
		}),
		// eslint-disable-next-line
		[]
	);

	return (
		<React.Fragment>
			<EditMemoDialog open={isEqual(openDialog, EDIT_MEMO_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<ProductSelectionDialog open={isEqual(openDialog, PRODUCT_SELECTION_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
		</React.Fragment>
	);
});

export default CreateOrderDialogBox;
